import Page from 'components/ui/Page'
import { useParams } from 'react-router-dom'
import SubscriptionView from './SubscriptionView'

const SubscriptionPage = () => {
    const { id } = useParams()
    return (
        <Page title={`Subscription #${id}`}>
            <SubscriptionView subscriptionId={id} />
        </Page>
    )
}

export default SubscriptionPage
